export var DocumentType;
(function (DocumentType) {
    DocumentType["VISA"] = "VISA";
    DocumentType["PASSPORT"] = "PASSPORT";
    DocumentType["MILITARY_IDENTIFICATION"] = "MILITARY_IDENTIFICATION";
    DocumentType["DRIVERS_LICENSE"] = "DRIVERS_LICENSE";
    DocumentType["NATIONAL_IDENTITY_DOCUMENT"] = "NATIONAL_IDENTITY_DOCUMENT";
    DocumentType["VACCINATION_CERTIFICATE"] = "VACCINATION_CERTIFICATE";
    DocumentType["ALIEN_REGISTRATION_NUMBER"] = "ALIEN_REGISTRATION_NUMBER";
    DocumentType["INSURANCE_POLICY_NUMBER"] = "INSURANCE_POLICY_NUMBER";
    DocumentType["TAX_EXEMPTION_NUMBER"] = "TAX_EXEMPTION_NUMBER";
    DocumentType["VEHICLE_REGISTRATION_LICENSE_NUMBER"] = "VEHICLE_REGISTRATION_LICENSE_NUMBER";
    DocumentType["BORDER_CROSSING_CARD"] = "BORDER_CROSSING_CARD";
    DocumentType["REFUGEE_TRAVEL_DOCUMENT"] = "REFUGEE_TRAVEL_DOCUMENT";
    DocumentType["PILOTS_LICENSE"] = "PILOTS_LICENSE";
    DocumentType["PERMANENT_RESIDENT_CARD"] = "PERMANENT_RESIDENT_CARD";
    DocumentType["REDRESS_NUMBER"] = "REDRESS_NUMBER";
    DocumentType["KNOWN_TRAVELER_NUMBER"] = "KNOWN_TRAVELER_NUMBER";
    DocumentType["NON_STANDARD"] = "NON_STANDARD";
    DocumentType["MERCHANT_MARINER"] = "MERCHANT_MARINER";
    DocumentType["AIR_NEXUS_CARD"] = "AIR_NEXUS_CARD";
    DocumentType["CREW_MEMBER_CERTIFICATE"] = "CREW_MEMBER_CERTIFICATE";
    DocumentType["PASSPORT_CARD"] = "PASSPORT_CARD";
    DocumentType["NATURALIZATION_CERTIFICATE"] = "NATURALIZATION_CERTIFICATE";
    DocumentType["CPF"] = "CPF";
    DocumentType["CEDULA"] = "CEDULA";
})(DocumentType || (DocumentType = {}));
